import { FormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { ApplicationService } from '../../services/application/application.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService } from '../../services/user/user.service';
import { PhonePipe } from '../../pipes/phone.pipe';
import { phoneNumberValidator } from '../../validators/phonenumber.validator';
var ParentContactComponent = /** @class */ (function () {
    function ParentContactComponent(appService, errorService, fb, phonePipe, splashService, userService) {
        this.appService = appService;
        this.errorService = errorService;
        this.fb = fb;
        this.phonePipe = phonePipe;
        this.splashService = splashService;
        this.userService = userService;
        this._subRelease = new Subject();
    }
    Object.defineProperty(ParentContactComponent.prototype, "phone", {
        get: function () {
            return this.contactForm.get('ContactPhone');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ParentContactComponent.prototype, "email", {
        get: function () {
            return this.contactForm.get('ContactEmail');
        },
        enumerable: true,
        configurable: true
    });
    ParentContactComponent.prototype.ngOnInit = function () {
        var self = this;
        self.LoadedEmail = null;
        self.LoadedPhone = null;
        self.PartialViewReady = false;
        self.ParentInfo = null;
        self.User = null;
        self.userService.UserSubject.pipe(takeUntil(self._subRelease), first(function (user) { return user != null && !!user.AuthToken; })).subscribe(function (user) {
            self.User = user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subRelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load student info so we can get access to the student ID and the current contact info
            combineLatest(self.appService.GetParentContactInformation(self.User.AuthToken), function (parent) {
                return {
                    Parent: parent,
                };
            })
                .pipe(takeUntil(self._subRelease))
                .subscribe(function (packet) {
                self.ParentInfo = packet.Parent;
                self.LoadedEmail = self.ParentInfo && self.ParentInfo.Email;
                var formattedPhone = self.phonePipe.transform(self.ParentInfo && self.ParentInfo.Phone, 'parensdash');
                self.LoadedPhone = formattedPhone;
                if (!self.contactForm) {
                    self.contactForm = self.fb.group({
                        ContactPhone: [formattedPhone, phoneNumberValidator()],
                        ContactEmail: [self.LoadedEmail, Validators.pattern(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)],
                    });
                }
                else {
                    self.contactForm.setValue({
                        ContactPhone: formattedPhone,
                        ContactEmail: self.LoadedEmail,
                    });
                }
                self.PartialViewReady = true;
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        }, function (error) {
            self.errorService.HandleServiceError(error);
        });
    };
    ParentContactComponent.prototype.ngOnDestroy = function () {
        this._subRelease.next();
        this._subRelease.complete();
    };
    // #region Update Parent Contact Info Method
    ParentContactComponent.prototype.UpdateParentContactInfo = function () {
        var self = this;
        var form = self.contactForm.value;
        if (!self.contactForm.valid) {
            return;
        }
        var cleanPhone = form.ContactPhone.replace(/[\(\)\-\s]/g, '');
        this.appService
            .UpdateParentContactInfo(self.User.AuthToken, self.User.UserID, self.User.FocusStaffID, cleanPhone, form.ContactEmail)
            .subscribe(function (info) {
            var formattedPhone = self.phonePipe.transform(info.Phone, 'parensdash');
            self.contactForm.setValue({
                ContactPhone: formattedPhone,
                ContactEmail: info.Email,
            });
            self.LoadedEmail = info.Email;
            self.LoadedPhone = formattedPhone;
            self.splashService.SnackbarSuccess('Contact information updated successfully.');
        }, function (error) {
            self.errorService.HandleServiceError(error);
        });
    };
    return ParentContactComponent;
}());
export { ParentContactComponent };



// WEBPACK FOOTER //
// ./src/app/parentcontact/parentcontact.component.ts.pre-build-optimizer.js